







































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { IFormStore } from '@/store/types'
import { koutsuhiPatternStore } from '@/store/form/KoutsuhiPatternFormStore'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { KeyInfo } from '@/components/common/form/types'
import KoutsuhiKeiroCard from '@/components/koutsuhi/molecules/KoutsuhiKeiroCard.vue'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'

@Component({
  components: { KoutsuhiKeiroCard }
})
export default class KoutsuhiPatternForm extends Mixins(FormStoreComponent) {
  @Prop({ default: '' })
  private patternId!: string

  get formName(): string {
    return 'koutsuhiPatternForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return koutsuhiPatternStore
  }
  get keyInfo(): KeyInfo {
    return { id: this.patternId }
  }

  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }

  private get keiroList(): ApiGeneralObjectArrayPayload {
    const keiroList = this.form.keiroList as ApiGeneralObjectArrayPayload
    if (!keiroList) {
      return []
    }
    return keiroList
  }
  private set keiroList(keiroList: ApiGeneralObjectArrayPayload) {
    this.updateValue('keiroList', keiroList)
  }
}
